// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"iframe-block-module--iframe-wrapper--fb8df"};